import React from 'react';
import { Typography, Grid, useTheme } from '@mui/material';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import PageMeta from './components/PageMeta';

const Mainentance = () => {
    const theme = useTheme();
    return (<>
        <PageMeta title="Maintenance | Curated Planet" />
        <Grid container direction="row" spacing={2} sx={{ margin: theme.spacing(2) }}>
            <Grid item xs={12}>
                <img width="155" height="24" alt="Curated Planet" src="https://public.curatedplanet.com/logo/curatedplanet_horizontal.png"/>
                <Typography gutterBottom variant="h4">Sorry, we are on maintenance</Typography>
                <Typography variant="body1">Curated Planet services are currently on maintenance. We promise to come back to you shortly!</Typography>
                <Typography variant="body1">
                We'll be back in 10 minutes.
                </Typography>
                <Typography variant="body1">You can follow us on Twitter for updates: <a href="https://twitter.com/touroptimainfo">@touroptimainfo</a></Typography>
            </Grid>
            <Grid item xs={12}>
                <TwitterTimelineEmbed
                    sourceType="profile"
                    screenName="touroptimainfo"
                    options={{ height: 400 }}
                />
            </Grid>
        </Grid>
    </>);
};

export default Mainentance;
